export default class FeatureFlag {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/featureflag";
  }

  getFeatureFlags() {
    return this.client.get(this.resourceUrl);
  }
}
